export enum AccountRole {
  ADMIN = 'ADMIN',
  NORMAL = 'NORMAL'
}
